import { render, staticRenderFns } from "./PlusCircleFilled.vue?vue&type=template&id=04038188&"
import script from "./PlusCircleFilled.vue?vue&type=script&setup=true&lang=js&"
export * from "./PlusCircleFilled.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports